import { render, staticRenderFns } from "./PlatformSecurity.vue?vue&type=template&id=f56a96a0&scoped=true&"
import script from "./PlatformSecurity.vue?vue&type=script&lang=js&"
export * from "./PlatformSecurity.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSecurity.vue?vue&type=style&index=0&id=f56a96a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56a96a0",
  null
  
)

export default component.exports